import { ApiService } from './api.service';
import { Competency, QuestionTypesWithCompetency, CompetencySettingType } from '@/models/competency/competency';
import { QuestionType } from '@/models/evalSetting/question-type';
import { AuthInfo } from '@/models/auth-info';
import { Trend } from '@/models/trend/trend';
import { Destination } from '@/models/jgrow/destination';
import { InterviewNaviCompetency } from '@/models/interview-navi/competency';
import { Language } from '@/models/language';

class MasterService extends ApiService {
  constructor() {
    super();
  }

  /**
   * Get competency list
   */
  getCompetencies(): Promise<Competency[]> {
    return this.getList(Competency, `/master/competencies`, {});
  }

  /**
   * Get competency list
   */
  getQuestionTypesWithCompetencies(): Promise<QuestionTypesWithCompetency[]> {
    return this.getList(QuestionTypesWithCompetency, `/master/questionTypesWithCompetencies`, {});
  }

  /**
   * Get competency list
   */
  getCompetencySettingTypes(): Promise<CompetencySettingType> {
    return this.get(CompetencySettingType, `/master/competencySettingTypes`, {});
  }

  getAuthInfo(): Promise<AuthInfo> {
    return new Promise(function(resolve, _) {
      setTimeout(() => resolve('done!'), 100);
      //setTimeout(()=> {  console.log(); }, 100);
    }).then(_ => {
      const mockData = require('@/assets/mock-data/users.json');
      return mockData.data.map((d: any) => new AuthInfo().deserialize(d));
    });
  }

  getQuestionTypes(): Promise<QuestionType[]> {
    return this.getList(QuestionType, `/master/questionTypes`, {});
  }

  getAllQuestionTypes(): Promise<QuestionType[]> {
    return this.getList(QuestionType, `/master/allQuestionTypes`, {});
  }

  getTrends(): Promise<Trend[]> {
    return this.getList(Trend, `/master/trends`, {});
  }

  // JGROW - 行き先取得
  getDestinations(): Promise<Destination[]> {
    return this.getList(Destination, `/jgrow/destination`, {});
  }

  getInterviewNaviCompetencies(): Promise<InterviewNaviCompetency[]> {
    return this.getList(InterviewNaviCompetency, `/master/interviewNavi/competencies`, {});
  }

  /**
   * 多言語対応言語取得
   */
  public fetchLanguages(): Promise<Language[]> {
    return this.getList(Language, '/master/languages', {});
  }
}

export const masterService = new MasterService();
